import RoundedButton from "../../../../Components/Buttons/RoundedButton";

const EvaluationFooter = ({
  primaryText = "تأكيد",
  secondaryText = "الرجوع",
  onPrimaryClick,
  onSecondaryClick,
  isSaving = false,
  disabled = false,
  showSecondary = false,
  className = "",
}) => {
  return (
    <div
      className={`evaluation-footer-fixed d-flex align-items-center justify-content-center gap-3 w-100 ${className}`}
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#ffffff",
        borderTop: "1px solid #e2e8f0",
        padding: "14px 24px",
        zIndex: 1030,
        direction: "rtl",
        boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.04)",
      }}
    >
      {showSecondary && (
        <button
          className="btn-back"
          onClick={onSecondaryClick}
          disabled={isSaving}
          type="button"
          style={{ height: "48px", padding: "0 28px", borderRadius: "12px" }}
        >
          {secondaryText}
        </button>
      )}

      <RoundedButton
        loading={isSaving}
        disabled={disabled || isSaving}
        text={isSaving ? "جاري الحفظ..." : primaryText}
        onClick={onPrimaryClick}
        bgColor="#64c8e2"
        color="#ffffff"
        maxWidth="220px"
        height={48}
        fontSize={16}
        radius={12}
        className="border-0 shadow-sm fw-bold"
      />
    </div>
  );
};

export default EvaluationFooter;
